"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  banner: {
    fontFamily: _theme.default.typography.proxima.regular,
    display: 'flex',
    borderRadius: '5px',
    overflow: 'hidden',
    boxShadow: '0px 2px 4px rgba(6, 21, 86, 0.15)',
    minHeight: '99px',
    width: '100%',
    lineHeight: '150%',
    [_theme.default.breakpoints.down('lg')]: {
      minHeight: '96px'
    },
    [_theme.default.breakpoints.down('sm')]: {
      flexDirection: 'column',
      borderRadius: '0',
      boxShadow: 'none'
    }
  },
  status: {
    display: 'flex',
    width: '60px',
    color: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    [_theme.default.breakpoints.down('sm')]: {
      width: '100%',
      minHeight: '40px',
      justifyContent: 'flex-start',
      paddingLeft: '20px'
    }
  },
  statusTitle: {
    fontSize: '16px',
    marginLeft: '12px',
    lineHeight: '150%',
    [_theme.default.breakpoints.down('sm')]: {
      fontFamily: _theme.default.typography.proxima.semiBold
    }
  },
  body: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    background: _theme.default.palette.white,
    padding: '20px',
    fontSize: '18px',
    lineHeight: '150%',
    flexGrow: '2',
    [_theme.default.breakpoints.down('lg')]: {
      fontSize: '16px'
    }
  },
  title: {
    fontFamily: _theme.default.typography.proxima.semiBold,
    fontSize: '18px',
    marginBottom: '5px',
    lineHeight: '150%'
  },
  content: {
    '& a': {
      textDecoration: 'none',
      color: _theme.default.palette.primary.light
    }
  }
});
var _default = exports.default = useStyles;